import type { ReadConfig } from 'api-read-hook';
import type { HydraCollection } from '../../types';

import { useApiRead } from 'api-read-hook';

export type V = {
  '@id': string;
  '@type': 'ClinicianDateAvailability';
  date: string | null;
  windows: Array<{
    '@id': string;
    '@type': 'TimeWindowDto';
    startTime: string;
    endTime: string;
  }>;
};

export type W = {
  days: Array<{
    date: string | null;
    windows: Array<{
      startTime: string;
      endTime: string;
    }>;
  }>;
};

export function useReadCollectionDateAvailabilities(
  id: string,
  options?: ReadConfig,
) {
  return useApiRead<HydraCollection<V>>(
    `/clinicians/${id}/date-availabilities`,
    options,
  );
}
